import { gql } from 'apollo-boost'

export const WALLET = gql`
  query userWalletForChat($data: userWalletForChat) {
    userWalletForChat(data: $data)
  }
`